import {
  collection,
  getDocs,
  getFirestore,
  query,
  updateDoc,
  where,
  doc,
} from 'firebase/firestore';
import { app } from '../../firebase';
import React, { useState } from 'react';
import { FaUserAlt, FaLock } from 'react-icons/fa';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from 'react-router-dom';
import backgroundImage from '../../assets/bg-green.webp';
import logo from '../../assets/tb-logo.jpg';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useAuthStore } from '../../utils/authStore';

const firestore = getFirestore(app);

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [resetEmail, setResetEmail] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [userDocId, setUserDocId] = useState(null);
  const setSession = useAuthStore((s) => s.setSession);

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const collectionRef = collection(firestore, 'employee');
      const que = query(
        collectionRef,
        where('email', '==', email),
        where('password', '==', password)
      );

      const response = await getDocs(que);

      if (response.empty) {
        toast.error('Invalid credentials');
        return;
      }

      const userDoc = response.docs[0];
      const userData = { id: userDoc.id, ...userDoc.data() };

      const { role, permissions } = userData;
      setSession({
        role,
        permissions:
          permissions ??
          userData.permission ??
          userData.Permissions ??
          userData.userPermissions,
        user: userData,
      });

      navigate('/dashboard');
      toast.success('Login successful');
    } catch (error) {
      console.error('Error during login:', error);
      toast.error('Error during login. Please try again.');
    }
  };

  const handleEmailCheck = async () => {
    try {
      const q = query(collection(firestore, 'employee'), where('email', '==', resetEmail));
      const snapshot = await getDocs(q);
      if (snapshot.empty) {
        toast.error('Email not found');
        return;
      }
      setUserDocId(snapshot.docs[0].id); // Save the document ID for update
    } catch (error) {
      toast.error('Error checking email');
      console.error(error);
    }
  };

  const handlePasswordReset = async () => {
    if (!newPassword || newPassword !== confirmPassword) {
      toast.error('Passwords do not match or are empty');
      return;
    }

    try {
      const userRef = doc(firestore, 'employee', userDocId);
      await updateDoc(userRef, { password: newPassword });
      toast.success('Password updated successfully');
      setShowModal(false);
      setResetEmail('');
      setNewPassword('');
      setConfirmPassword('');
    } catch (error) {
      toast.error('Failed to update password');
      console.error(error);
    }
  };

  return (
    <div
      className="d-flex align-items-center justify-content-center"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        height: '100vh',
      }}
    >
      <ToastContainer />
      <div className="card shadow-lg p-5" style={{ maxWidth: '450px' }}>
        <div className="text-center mb-4">
          <img src={logo} alt="Company Logo" className="mb-2" style={{ width: '120px' }} />
          <h2 className="fw-bold">MoneyCart Login</h2>
        </div>

        <form onSubmit={handleLogin}>
          <div className="mb-3">
            <label htmlFor="email" className="form-label">Email</label>
            <div className="input-group">
              <span className="input-group-text"><FaUserAlt /></span>
              <input
                id="email"
                type="text"
                className="form-control"
                placeholder="Enter your Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
          </div>

          <div className="mb-3">
            <label htmlFor="password" className="form-label">Password</label>
            <div className="input-group">
              <span className="input-group-text"><FaLock /></span>
              <input
                id="password"
                type="password"
                className="form-control"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
          </div>

          <div className="d-flex justify-content-between mb-3">
            <div>
              <input type="checkbox" id="remember-me" className="form-check-input" />
              <label htmlFor="remember-me" className="form-check-label ms-2">Remember me</label>
            </div>
            <a href="#!" className="text-decoration-none text-primary" onClick={() => setShowModal(true)}>
              Forgot Password?
            </a>
          </div>

          <div className="text-center">
            <button type="submit" className="btn btn-success w-100">Sign In</button>
          </div>
        </form>
      </div>

      {/* Reset Password Modal */}
      {showModal && (
        <div className="modal show fade d-block" tabIndex="-1">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Reset Password</h5>
                <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
              </div>
              <div className="modal-body">
                {!userDocId ? (
                  <>
                    <label className="form-label">Enter your registered email</label>
                    <input
                      type="email"
                      className="form-control mb-3"
                      value={resetEmail}
                      onChange={(e) => setResetEmail(e.target.value)}
                      placeholder="example@domain.com"
                    />
                    <button className="btn btn-success w-100" onClick={handleEmailCheck}>Next</button>
                  </>
                ) : (
                  <>
                    <label className="form-label">Enter New Password</label>
                    <input
                      type="password"
                      className="form-control mb-2"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      placeholder="New password"
                    />
                    <input
                      type="password"
                      className="form-control mb-3"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      placeholder="Confirm password"
                    />
                    <button className="btn btn-success w-100" onClick={handlePasswordReset}>Reset Password</button>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Login;
